import * as constants from './constants'

export const initCreditCardAddView = () => ({
    type: constants.INIT_CREDIT_CARD_ADD,
})

export const selectCreditCardBrand = (iframeName, creditCardBrand) => ({
    type: constants.CREDIT_CARD_BRAND_SELECTED,
    name: iframeName,
    creditCardBrand,
})

export const ingenicoVerificationFailed = errors => ({
    type: constants.INGENICO_VERIFICATION_FAILED,
    errors,
})

export const init3DSecureFlow = () => ({
    type: constants.INIT_3DSECURE_FLOW,
})

export const clearErrors = () => ({
    type: constants.CLEAR_ERRORS,
})
